//更新头部标题
export const UPDATE_TITLE = 'UPDATE_TITLE';


// WEBPACK FOOTER //
// ./src/store/global/mutations_types.js